import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { PartnerSelect } from '../../components';
import { InputModelWithSource } from '../../models';
import { ValidationMessages } from '../../misc';
import { InputWithSource } from '../../componentTypes';
import { useBaseCompanySubscription } from '../../hooks';

const ReinsurerInput: InputWithSource = ({ input }) => {
    useBaseCompanySubscription(input);

    return (
        <PartnerSelect
            label={input.name}
            input={input}
            message={ValidationMessages.requiredInput(input.name)}
            plainLabels
        />
    );
};

ReinsurerInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(ReinsurerInput);
